export default __webpack_public_path__ + "static/media/default-vote-icon.02d95838.svg";